<template>
    <div class="page-bread">
        <ul class="page-breadcrumb">
            <li>
                <i class="icon-home"></i>
                <a href="" class="bread-label">首页</a>
            </li>
            <i class="fa fa-angle-right"></i>
            <li>
                <a :href="currentUrl" class="bread-label">{{currentUrlName}}</a>
            </li>
        </ul>
    </div>   
</template>

<script>
    export default{
        props:{
            currentUrl:String,
            currentUrlName:String
        },
        data(){
            return{
            }
        },
        mounted(){
            
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/page-bread.vue